"use client";

import { useEffect, useState } from "react";

import type { WidgetPosition } from "./widget-config";
import { resolveResponsiveWidgetPosition } from "./widget-config";

const MOBILE_MQ = "(max-width: 575.98px)";
const TABLET_MQ = "(min-width: 576px) and (max-width: 1199.98px)";

/**
 * Re-evaluates launcher position when viewport crosses legacy Skinny breakpoints.
 */
export function useResponsiveWidgetPosition(
  basePosition: WidgetPosition,
  responsive?: {
    readonly positionDesktop?: WidgetPosition;
    readonly positionMobile?: WidgetPosition;
    readonly positionTablet?: WidgetPosition;
  },
): WidgetPosition {
  const [position, setPosition] = useState<WidgetPosition>(() =>
    resolveResponsiveWidgetPosition(basePosition, responsive),
  );

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }

    const mobileMq = window.matchMedia(MOBILE_MQ);
    const tabletMq = window.matchMedia(TABLET_MQ);

    const apply = () => {
      setPosition(resolveResponsiveWidgetPosition(basePosition, responsive));
    };

    apply();
    mobileMq.addEventListener("change", apply);
    tabletMq.addEventListener("change", apply);
    return () => {
      mobileMq.removeEventListener("change", apply);
      tabletMq.removeEventListener("change", apply);
    };
  }, [basePosition, responsive]);

  return position;
}
